import React from 'react'
import { Title, Button } from 'components/atoms'
import { Modal } from 'components/molecules'
import { ModuleSelect } from 'components/organisms'
import PropTypes from 'prop-types'
import { useUserContext } from 'context/UserContext';

const PageAddModuleModal = ({ isOpen, toggle, onSelect }) => {
  const [{ user }] = useUserContext()
  const isAdmin = user && user.admin

  const handleSelect = (organism) => {
    onSelect(organism)
    toggle()
  }

  const handleDiscard = () => {
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top>
        <Title>
          Adicionar módulo
        </Title>
      </Modal.Top>
      <ModuleSelect
        onSelect={handleSelect}
        isAdmin={isAdmin}
      />
      <Modal.Actions>
        <Button
          type="button"
          modifiers={['marginRight', 'capitalize']}
          onClick={handleDiscard}
        >
            Cancelar
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

PageAddModuleModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  onSelect: PropTypes.func,
}

PageAddModuleModal.defaultProps = {
  isOpen: false,
  toggle: () => {},
  onSelect: () => {}
}

export default PageAddModuleModal
